<template>
    <DsModal
        :is-open="isOpen"
        show-close
        size="fluid"
        :title="$t('funnel.reporting.sequence.email.report.title')"
        @close="closeModal"
    >
        <template #default>
            <div class="date-picker-container-email-report">
                <DsDatePicker
                    v-model="selectedDateRangeValue"
                    range
                    bind-value-only
                    :label="$t('funnel.reporting.sequence.email.report.data.range.label')"
                    @input="loadReport"
                />
            </div>
            <div
                class="table-grid-container-scroll"
            >
                <DsTableGrid
                    ref="reportValues"
                    :data="reportValues"
                    data-qa="report-values-grid"
                >
                    <DsTableGridColumn
                        :label="$t('funnel.reporting.sequence.email.report.table.decision')"
                        prop="flowName"
                        width="50"
                        data-qa="sequence-column-id"
                    />
                    <DsTableGridColumn
                        :label="$t('funnel.reporting.sequence.email.report.table.email')"
                        prop="emailFlowItemName"
                        width="50"
                        data-qa="email-column-id"
                    />
                    <DsTableGridColumn
                        :label="$t('funnel.reporting.sequence.email.report.table.subject')"
                        prop="emailSubject"
                        width="80"
                        data-qa="subject-column-id"
                    />
                    <DsTableGridColumn
                        :label="$t('funnel.reporting.sequence.email.report.table.sent')"
                        prop="sentCount"
                        width="40"
                        data-qa="sent-column-id"
                    />
                    <DsTableGridColumn
                        :label="$t('funnel.reporting.sequence.email.report.table.delivered')"
                        prop="deliveredCount"
                        width="40"
                        data-qa="delivered-column-id"
                    />
                    <DsTableGridColumn
                        :label="$t('funnel.reporting.sequence.email.report.table.opens')"
                        prop="openedCount"
                        width="40"
                        data-qa="opens-column-id"
                    />
                    <DsTableGridColumn
                        :label="$t('funnel.reporting.sequence.email.report.table.clicks')"
                        prop="clickedCount"
                        width="40"
                        data-qa="clicked-column-id"
                    />
                    <DsTableGridColumn
                        :label="$t('funnel.reporting.sequence.email.report.table.click.to.open.rate')"
                        prop="clickToOpenRatio"
                        width="60"
                        sortable
                        data-qa="clicked-column-id"
                    />
                </DsTableGrid>
            </div>
            <div
                v-if="reportValues.length === 0"
                class="empty-state-container"
            >
                {{ $t('funnel.reporting.sequence.email.report.table.no.emails') }}
            </div>
        </template>
    </DsModal>
</template>

<script>
import {
    getFullSequenceEmailReport,
} from '../campaign.api';
import {
    formatDateAsString,
} from '../utils/date-utils';

export default {
    name: 'SequenceAndEmailReport',
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
        funnelId: {
            type: String,
            required: true,
        },

        dateRange: {
            type: Array,
            required: true,
        },

        isUkDateLocale: {
            type: Boolean,
            required: true,
        },
    },

    emits: ['close-sequence-email-report-modal'],

    data() {
        return {
            selectedDateRangeValue: this.dateRange,
            reportValues: [],
        };
    },

    async mounted() {
        await this.loadReport();
    },
    methods: {
        closeModal() {
            this.$emit('close-sequence-email-report-modal');
        },

        async loadReport() {
            this.reportValues = [];
            const startDate = formatDateAsString(this.selectedDateRangeValue[0], !this.isUkDateLocale);
            const endDate = formatDateAsString(this.selectedDateRangeValue[1], !this.isUkDateLocale);

            if (startDate && endDate) {
                const data = await getFullSequenceEmailReport(this.funnelId, startDate, endDate);

                data.forEach((element) => {
                    const row = {};

                    row.flowName = element.flowName;
                    row.emailFlowItemName = element.emailFlowItemName;
                    row.emailSubject = element.emailSubject;
                    row.sentCount = element.emailStats.sentCount;
                    row.deliveredCount = element.emailStats.deliveredCount;
                    row.openedCount = element.emailStats.openedCount;
                    row.clickedCount = element.emailStats.clickedCount;
                    row.clickToOpenRatio = element.emailStats.clickToOpenRatio;

                    this.reportValues.push(row);
                });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
    .empty-state-container {
        padding-top: px-to-rem(20px);
    }

    .date-picker-container-email-report {
        left: 0;
        max-width: px-to-rem(500px);
    }

    .table-grid-container-scroll {
        overflow-y: auto;
        max-height: 65vh;
    }
</style>

<style lang="scss">
    .date-picker-container-email-report .date-picker-container label {
        padding-top: 0;
    }
</style>
